import React from 'react';
import { Theme } from '@mui/material/styles';
import SearchIcon from '@mui/icons-material/Search';
import { AutocompleteStoryInput } from './AutocompleteStory';
import { useSetAtom } from 'jotai';
import { searchState, selectedCategory } from './JotaiAtoms';
import { useProjectCaptions } from './hooks';
import Box from '@mui/material/Box';

export function AppBarSearch() {
  const setSearch = useSetAtom(searchState);
  const setCategory = useSetAtom(selectedCategory);
  const captions = useProjectCaptions();

  const handleSelected = (val: string) => {
    if (!val) return;
    setSearch(val.trim());
    setCategory('Stories');
  };

  return (
    <Box
      sx={{
        width: '100%',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <SearchIcon
        sx={{
          position: 'absolute',
          left: 14,
          zIndex: 1,
          fontSize: '20px',
          color: (theme: Theme) => theme.palette.mode === 'dark' ? '#9aa0a6' : '#5f6368',
          pointerEvents: 'none',
        }}
      />
      <Box sx={{ width: '100%' }}>
        <AutocompleteStoryInput
          placeholderText="Search stories..."
          onSelected={handleSelected}
          variant="outlined"
          options={captions}
          fullWidth={true}
          hideSearchIcon={true}
          sx={{
            width: '100%',
            '& .MuiTextField-root': {
              width: '100%',
            },
            '& .MuiOutlinedInput-root': {
              width: '100%',
              height: '40px',
              borderRadius: '20px',
              paddingLeft: '40px',
              backgroundColor: (theme: Theme) => theme.palette.mode === 'dark'
                ? 'rgba(232, 234, 237, 0.08)'
                : '#f1f3f4',
              transition: 'all 0.2s cubic-bezier(0.4, 0.0, 0.2, 1)',
              border: 'none',
              '& fieldset': {
                border: 'none',
              },
              '&:hover': {
                backgroundColor: (theme: Theme) => theme.palette.mode === 'dark'
                  ? 'rgba(232, 234, 237, 0.12)'
                  : '#e8eaed',
              },
              '&.Mui-focused': {
                backgroundColor: (theme: Theme) => theme.palette.mode === 'dark'
                  ? 'rgba(232, 234, 237, 0.16)'
                  : '#ffffff',
                boxShadow: (theme: Theme) => theme.palette.mode === 'dark'
                  ? '0 1px 3px rgba(0, 0, 0, 0.3)'
                  : '0 1px 3px rgba(0, 0, 0, 0.15)',
              },
              '& input': {
                padding: '8px 14px',
                fontSize: '14px',
                color: (theme: Theme) => theme.palette.mode === 'dark' ? '#e8eaed' : '#202124',
                '&::placeholder': {
                  color: (theme: Theme) => theme.palette.mode === 'dark' ? '#9aa0a6' : '#5f6368',
                  opacity: 1,
                },
              },
            },
          }}
        />
      </Box>
    </Box>
  );
}
